import React, { useEffect, useState } from 'react'
import { CardHeader, EncuestaLoading, InfoCard, NameLabel, ThanksMessage, checkEncuesta, onFinishFailed, getNextSurveyUrl } from '../utils'
import { Form, Input, Button, message, Radio } from 'antd'
import { sendDataBody } from '../../resources'
import { gad7_catalog } from './gad7.catalog'
export default function Gad7Encuesta({ idpaciente, idmedico, token, visita, session, protocolo = 'default', chain = '' }) {

    const [encuestaNotExists, setEncuestaNotExists] = useState(null)
    const [checking, setChecking] = useState(true)
    const [pacienteData, setPacienteData] = useState({})
    const [medicoData, setMedicoData] = useState({})

    useEffect(() => {
        init()
    }, [])

    function init() {
        checkEncuesta(idpaciente, visita, 'gad_7', session, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking)
    }

    const nextSurveyUrl = getNextSurveyUrl('gad_7', chain, idmedico, idpaciente, token, visita, session, protocolo);

    const onFinish = (values) => {
        console.log('Orginal values: ', values)
        const body = {
            usuario: idpaciente,
            medico: idmedico,
            gad_7: Object.values(values),
            tipo: 'gad_7',
            uuid: token,
            visita: visita,
            sesion: session,
            protocolo: protocolo
        }
        console.log('Body:', body);
        sendDataBody('encuestas/add', body).then((rs) => {
            console.log('add enc resp', rs)
            message.success(rs.message)
        }).then(() => init())
    };

    const onChange = (e) => {
        console.log('radio checked', e.target.value);
    };

    const Instructions = () => {
        return <p>
            Durante las  <u>últimas 2 semanas</u>, ¿qué tan seguido ha tenido molestias debido a los siguientes problemas?
            <br /> <span style={{ fontSize: 14 }}>(Selecciona una respuesta)</span>
        </p>
    }

    if (checking) return <EncuestaLoading />

    if (!encuestaNotExists) return <ThanksMessage nextUrl={nextSurveyUrl} />

    return (
        <div className='parentContainer'>
            <CardHeader title="Escala GAD-7">
                <NameLabel pacienteData={pacienteData} />

                <NameLabel pacienteData={medicoData} label="Médico: " />

                <InfoCard label="Sesión" value={session} />
            </CardHeader>
            <div className='formContainer'>
                <Instructions />

                <Form
                layout='vertical'
                name="gad7_enc"
                className="numberedQuestions"
                // labelCol={{ span: 24 }}
                // wrapperCol={{ span: 24 }}
                initialValues={[]}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                {
                    gad7_catalog.map((q, i) => <Form.Item
                        label={q}
                        name={i}
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >
                        <Radio.Group onChange={onChange} >
                            <Radio value={0}>Ningún día</Radio>
                            <Radio value={1}>Varios días</Radio>
                            <Radio value={2}>Más de la mitad de los días</Radio>
                            <Radio value={3}>Casi todos los días</Radio>
                        </Radio.Group>
                    </Form.Item>)
                }

                <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button form='gad7_enc' type="primary" htmlType="submit">
                        Enviar respuestas
                    </Button>
                </Form.Item>
                {/* <Button type='primary' onClick={navToUrl} style={{ alignSelf: 'center' }}>Siguiente</Button> */}
            </Form>
            </div>
        </div>
    )
}